
import Title from "@/components/helpers/Title.vue";
import TitleStyle from "@/components/style/Title.vue";
import Button from "@/components/input-2/Button.vue";

export default {
  components: {Button, Title, TitleStyle},
  props: {
    searches: {},
    aircompanies: {},
    airports: {},
    label: {default: false}
  },
  methods: {
    trips(search) {
      let flightCode = search.aircompany.split('/');
      if (flightCode.length === 1) {
        return [0];
      } else {
        return [0, 1];
      }
    },
    aircompanyForTrip(search, index) {
      let flightCode = search.aircompany.split('/');
      if (flightCode.length === 1) {
        return this.aircompany(flightCode[0].split('-')[0]);
      } else {
        return this.aircompany(flightCode[index].split('-')[0]);
      }
    },
    aircompany(code) {
      return this.aircompanies.find(aircompany => aircompany.code === code);
    },
    airport(airport_code) {
      return this.airports.find(airport => airport.airport_code === airport_code);
    }
  }
}
